import React from "react";
import PropTypes from "prop-types";

// Styles
import styles from "./styles.module.css";

const Pill = ({ children }) => {
	return <div className={styles.container}>{children}</div>;
};

Pill.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Pill;
